import {
  TLGroupShape,
  TLPageId,
  TLParentId,
  TLShapeId,
  TLUnknownShape,
  groupShapeMigrations,
  groupShapeProps,
} from "tldraw"
import {
  ShapeUtil,
  Geometry2d,
  Rectangle2d,
  Group2d,
  SVGContainer,
} from "tldraw"
import { DashedOutlineBox } from "./group/DashedOutlineBox"
import { LiveDraw } from "../LiveDraw"
import { LDGroupShape, ldGroupShapeProps } from "../../shared/LDShape"
import { Expr } from "../../shared/Expr"
import {
  CloneOptions,
  CustomDrawShapeProps,
} from "../../shared/CustomDrawShape"
import { LDPage } from "../../shared/LDPage"
import { flattenParams } from "./flattenParams"

/** @public */
export class LDGroupShapeUtil extends ShapeUtil<LDGroupShape> {
  static override type = "custom-group" as const
  static override props = ldGroupShapeProps
  static override migrations = groupShapeMigrations

  override hideSelectionBoundsFg() {
    return false
  }

  override canBind() {
    return false
  }

  canResize() {
    return true
  }

  canResizeChildren() {
    return true
  }

  getDefaultProps(): LDGroupShape["props"] {
    const currentPage = this.editor.getCurrentPage() as LDPage
    return {
      pageId: currentPage.id,
      layer: currentPage.meta.currentLayer,
      parameterValues: {},
    }
  }

  getGeometry(shape: LDGroupShape): Geometry2d {
    const children = this.editor.getSortedChildIdsForParent(shape.id)
    if (children.length === 0) {
      return new Rectangle2d({ width: 1, height: 1, isFilled: false })
    }

    return new Group2d({
      children: children.map((childId) => {
        const shape = this.editor.getShape(childId)!
        return this.editor
          .getShapeGeometry(childId)
          .transform(this.editor.getShapeLocalTransform(shape)!, {
            isLabel: false,
          })
      }),
    })
  }

  component(shape: LDGroupShape) {
    const isErasing = this.editor.getErasingShapeIds().includes(shape.id)

    const { hintingShapeIds } = this.editor.getCurrentPageState()
    const isHintingOtherGroup =
      hintingShapeIds.length > 0 &&
      hintingShapeIds.some(
        (id) =>
          id !== shape.id &&
          this.editor.isShapeOfType<LDGroupShape>(
            this.editor.getShape(id)!,
            "custom-group",
          ),
      )

    const isFocused =
      this.editor.getCurrentPageState().focusedGroupId !== shape.id

    const params = flattenParams(shape, this.editor)
    console.log("group render", shape.id)

    if (shape.props.clone?.num) {
      for (let i = 1; i <= Expr.evaluate(shape.props.clone.num, params); i++) {
        console.log({ i })
        console.log(Expr.evaluate(shape.props.clone.num, params))
        this.editor.getShapeAndDescendantIds([shape.id]).forEach((shapId) => {
          const childShape = this.editor.getShape(shapId)
          if (
            !childShape ||
            (childShape.props as CustomDrawShapeProps)?.isClone
          )
            return
          console.log("hello")
          this.editor.createShape({
            ...childShape,
            id: (childShape.id + i * -1) as TLShapeId,
            x:
              childShape.x +
              Expr.evaluate(
                shape.props.clone!.transformation.translateX,
                params,
              ) *
                i,
            y:
              childShape.y +
              Expr.evaluate(
                shape.props.clone!.transformation.translateY,
                params,
              ) *
                i,

            props:
              childShape.id === shape.id
                ? { ...childShape.props, clone: undefined, isClone: true }
                : childShape.props,
            parentId:
              childShape.id === shape.id
                ? childShape.parentId
                : ((childShape.parentId + i * -1) as TLParentId),
            isLocked: true,
          })
        })
      }
      // if (shape.props.clone) {
      //   const clones = this.editor
      //     .getCurrentPageShapes()
      //     .filter((s) => s.id.startsWith(shape.id) && s.id !== shape.id)
      //   console.log({ clones })
      //   clones
      //     .filter((sh) => {
      //       const n = Number(sh.id.substring(shape.id.length))
      //       console.log({ n })

      //       console.log(
      //         "num",
      //         Expr.evaluate((shape.props.clone as CloneOptions).num, params),
      //       )
      //       return (
      //         -1 * n >
      //         Expr.evaluate((shape.props.clone as CloneOptions).num, params)
      //       )
      //     })
      //     .forEach((shap) => {
      //       console.log("deleting shape", shap)
      //       this.editor.updateShape({
      //         ...shap,
      //         isLocked: false,
      //       })
      //       const shapesToDelete = this.editor.getShapeAndDescendantIds([
      //         shap.id,
      //       ])
      //       console.log({ shapesToDelete })
      //       this.editor.deleteShapes([...shapesToDelete])
      //     })
      // }
    }

    if (
      !isErasing && // always show the outline while we're erasing the group
      // show the outline while the group is focused unless something outside of the group is being hinted
      // this happens dropping shapes from a group onto some outside group
      (isFocused || isHintingOtherGroup)
    ) {
      return null
    }

    const bounds = this.editor.getShapeGeometry(shape).bounds

    // return (
    //   <SVGContainer>
    //     <DashedOutlineBox className="tl-group" bounds={bounds} />
    //   </SVGContainer>
    // )
  }

  indicator(shape: LDGroupShape) {
    // Not a class component, but eslint can't tell that :(
    const bounds = this.editor.getShapeGeometry(shape).bounds
    const page = this.editor.getCurrentPage() as LDPage
    const targetPage = this.editor.getPage(shape.props.pageId)
    const zoom = this.editor.getZoomLevel()
    const cx = bounds.x + bounds.width / 2
    const cy = bounds.y - 10
    return (
      // This is kind of a hack to show the page name above the group, should redo properly with InFrontOfTheCanvas
      (this.editor.getHoveredShapeId() === shape.id ||
        page.meta.focusedLayerId === shape.props.layer ||
        this.editor.getSelectedShapeIds().includes(shape.id)) && (
        <>
          <text
            x={0}
            y={0}
            transform={`translate(${cx}, ${cy}) scale(${1 / zoom})`}
            textAnchor="middle"
            style={{
              pointerEvents: "none",
              fontSize: 12,
              fill: "#000", // or whatever color you want
              stroke: "none",
            }}
          >
            {targetPage!.name}
          </text>

          <DashedOutlineBox className="" bounds={bounds} />
        </>
      )
    )
  }

  override onChildrenChange(group: LDGroupShape) {
    // const children = this.editor.getSortedChildIdsForParent(group.id)
    // if (children.length === 0) {
    //   if (this.editor.getCurrentPageState().focusedGroupId === group.id) {
    //     this.editor.popFocusedGroupId()
    //   }
    //   this.editor.deleteShapes([group.id])
    //   return
    // } else if (children.length === 1) {
    //   if (this.editor.getCurrentPageState().focusedGroupId === group.id) {
    //     this.editor.popFocusedGroupId()
    //   }
    //   this.editor.reparentShapes(children, group.parentId)
    //   this.editor.deleteShapes([group.id])
    //   return
    // }
  }
}
